import { UseQueryResult, useQuery } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { PosData } from "../types/pos.type";

export const usePosMachineById: (id: string) => UseQueryResult<PosData, unknown> = (id) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{data: {data: PosData}}, unknown, PosData>({
    queryKey: ['posMachineById', id],
    queryFn: () => privateAxios.get(`/pos/machines/${id}`),
    enabled: !!id,
    select: (data) => {
      return data?.data?.data
    }
  })
}